export const CalculateAge = _birthdate => {
  var today = new Date()
  var birthDate = new Date(_birthdate.replace(/\s/g, "T"))

  if (birthDate instanceof Date && !isNaN(birthDate)) {
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  return false
}
